import React from 'react';
import { RiLink } from 'react-icons/ri';
import { Booking } from '../types/booking.types';

interface BookingHeaderProps {
  booking: Booking;
  onBack: () => void;
  onCreateReviewLink?: () => void;
}

const BookingHeader: React.FC<BookingHeaderProps> = ({ booking, onBack, onCreateReviewLink }) => {
  const isCompleted = String(booking.status || '').toLowerCase() === 'completed';

  const getStatusColor = (status: string): string => {
    switch (status) {
      case 'pending':
        return 'bg-yellow-100 text-yellow-700';
      case 'completed':
        return 'bg-green-100 text-green-700';
      case 'cancelled':
        return 'bg-red-100 text-red-700';
      default:
        return 'bg-blue-100 text-blue-700';
    }
  };

  return (
    <div className="flex items-center justify-between mb-6 pb-4 border-b-2 border-gray-200">
      <div>
        <h2 className="text-2xl font-bold text-gray-800">Booking Details</h2>
        <p className="text-sm text-gray-500 mt-1">
          Booking Code: <span className="font-semibold text-gray-700">{booking.booking_code}</span>
        </p>
      </div>
      <div className="flex items-center space-x-3">
        <span className={`px-4 py-2 rounded-full text-sm font-semibold ${getStatusColor(booking.status)}`}>
          {booking.status?.toUpperCase()}
        </span>
        {isCompleted && onCreateReviewLink && (
          <button
            type="button"
            onClick={onCreateReviewLink}
            className="inline-flex items-center gap-2 rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white hover:bg-blue-700"
          >
            <RiLink size={16} />
            Review Link
          </button>
        )}
        <button
          type="button"
          onClick={onBack}
          className="px-3 py-1 text-base font-semibold text-blue-600 hover:text-blue-800"
        >
          Back
        </button>
      </div>
    </div>
  );
};

export default BookingHeader;
